import React, { useEffect } from 'react';

/**
 * LegalDocRedirect — /terms and /privacy now point at the FULL standalone legal
 * documents (the same versions the latest Burrow Lite shipped, byte-identical to
 * the CDN copies). React Router can't serve a static .html from a client route,
 * so this tiny component performs a real browser navigation to the document.
 */
const LegalDocRedirect = ({ file }) => {
  useEffect(() => {
    window.location.assign(`${process.env.PUBLIC_URL}${file}`);
  }, [file]);
  return null;
};

export default LegalDocRedirect;
